module.exports = __webpack_public_path__ + "media/images/big/img5-58234d565d0c7ae1fc762eed7033966a.jpg";